export const interestOptions = [
  {
    label: '(Spouw)muur<wbr>isolatie',
    value: 'Cavity Wall',
    icon: 'bi-house-wall',
    searchKeys: ['spouw', 'cavity'],
    viewName: 'formCavityWall',
    hidden: false
  },
  {
    label: 'Dakisolatie',
    value: 'Roof',
    icon: 'bi-house-roof',
    searchKeys: ['dak', 'roof'],
    viewName: 'formRoof',
    hidden: false
  },
  {
    label: 'Vloerisolatie',
    value: 'Floor',
    icon: 'bi-house-floor',
    searchKeys: ['floor', 'vloer', 'bodem'],
    viewName: 'formFloor',
    hidden: false
  },
  {
    label: 'HR++ of triple -glas in bestaande of nieuwe kozijnen',
    value: 'Glazing',
    icon: 'bi-house-window',
    searchKeys: ['glas', 'glaz'],
    viewName: 'formGlazing',
    hidden: false
  },
  {
    label: 'Zonnepanelen',
    value: 'Solar',
    icon: 'bi-solar-roof',
    searchKeys: ['zonne', 'solar', 'panelen', 'pv'],
    viewName: 'formSolar',
    hidden: true
  },
  {
    label: 'Warmtepomp',
    value: 'Heatpump',
    icon: 'bi-heatpump',
    searchKeys: ['warmtepomp', 'airco', 'heatpump'],
    viewName: 'formHeatpump',
    hidden: true
  },
  {
    label: 'Ventilatie',
    value: 'Ventilation',
    icon: 'bi-fan',
    searchKeys: ['ventil'],
    viewName: 'formVentilation',
    hidden: true
  },
]

export const m29Interests = [
  'Isolatieplan Maatregel 29',
  'Ondersteuning Nij Begun',
]

export function getInterestDefinition(interestValue = null, loose = false) {
  // if loose normalize first
  if (loose) {
    interestValue = normalizeInterestValue(interestValue);
  }
  // find and return interest definition object
  for (const interest of interestOptions) {
    if (interest.value == interestValue) {
      return interest;
    }
  }
  // else return null
  return null;
}

export function normalizeInterestValue(searchString = null) {
  if (!searchString) {
    return null;
  }
  // search interests by search keys
  let searchString_lc = String(searchString).toLowerCase();
  for (const interest of interestOptions) {
    // exact match
    if (interest.value == searchString) {
      return interest.value;
    }
    // loose match
    for (const sk of interest.searchKeys) {
      if (searchString_lc.includes(sk)) {
        return interest.value;
      }
    }
  }
  // else return null
  return null;
}

export function getInterestDefinitions($showHidden = false, whitelistOnly = null)
{
  if (whitelistOnly) {
    // return only interests that are in the whitelist
    return interestOptions.filter(interest => whitelistOnly.includes(interest.value));
  } else if ($showHidden) {
    return interestOptions;
  } else {
    // return interests where hidden = false
    return interestOptions.filter(interest => interest.hidden == false);
  }
}